export const PROPERTY_CATEGORIES = ['residential', 'commercial'];

export const PROPERTY_CATEGORY_LABELS = {
  residential: 'Residential',
  commercial: 'Commercial',
};

export const SERVICE_TYPES_BY_CATEGORY = {
  residential: ['standard_clean', 'deep_clean', 'move_out', 'recurring_maintenance'],
  commercial: ['standard_clean', 'deep_clean', 'move_out', 'post_construction'],
};

export const SERVICE_TYPE_LABELS = {
  standard_clean: 'Standard clean',
  deep_clean: 'Deep clean',
  move_out: 'Move-out clean',
  recurring_maintenance: 'Recurring maintenance',
  post_construction: 'Post-construction clean',
};

export const ACCOUNT_TYPE_FOR_CATEGORY = {
  residential: 'residential',
  commercial: 'business',
};

export const SCOPE_ITEMS_BY_CATEGORY = {
  residential: {
    standard_clean: [
      { key: 'kitchen', label: 'Kitchen (counters, sink, appliances exterior)' },
      { key: 'bathrooms', label: 'Bathrooms' },
      { key: 'floors', label: 'Floors (vacuum & mop)' },
      { key: 'dusting', label: 'Dusting (surfaces & furniture)' },
      { key: 'bedrooms', label: 'Bedrooms' },
      { key: 'living_areas', label: 'Living & dining areas' },
      { key: 'trash_removal', label: 'Trash removal' },
      { key: 'interior_windows', label: 'Interior windows' },
    ],
    deep_clean: [
      { key: 'kitchen', label: 'Kitchen (counters, sink, appliances exterior)' },
      { key: 'bathrooms', label: 'Bathrooms (deep scrub)' },
      { key: 'floors', label: 'Floors (vacuum & mop)' },
      { key: 'dusting', label: 'Dusting (surfaces & furniture)' },
      { key: 'bedrooms', label: 'Bedrooms' },
      { key: 'living_areas', label: 'Living & dining areas' },
      { key: 'inside_oven', label: 'Inside oven' },
      { key: 'inside_fridge', label: 'Inside refrigerator' },
      { key: 'baseboards', label: 'Baseboards' },
      { key: 'cabinet_fronts', label: 'Cabinet fronts' },
      { key: 'light_fixtures', label: 'Light fixtures & ceiling fans' },
      { key: 'interior_windows', label: 'Interior windows' },
      { key: 'trash_removal', label: 'Trash removal' },
    ],
    move_out: [
      { key: 'kitchen', label: 'Kitchen (full clean)' },
      { key: 'bathrooms', label: 'Bathrooms (full clean)' },
      { key: 'floors', label: 'Floors (vacuum & mop)' },
      { key: 'dusting', label: 'Dusting (all rooms)' },
      { key: 'bedrooms', label: 'Bedrooms' },
      { key: 'living_areas', label: 'Living & dining areas' },
      { key: 'inside_oven', label: 'Inside oven' },
      { key: 'inside_fridge', label: 'Inside refrigerator' },
      { key: 'inside_cabinets', label: 'Inside cabinets & drawers' },
      { key: 'inside_closets', label: 'Inside closets' },
      { key: 'baseboards', label: 'Baseboards' },
      { key: 'interior_windows', label: 'Interior windows' },
      { key: 'garage', label: 'Garage' },
      { key: 'patio_deck', label: 'Patio / deck' },
      { key: 'trash_removal', label: 'Trash removal' },
    ],
    recurring_maintenance: [
      { key: 'kitchen', label: 'Kitchen touch-up' },
      { key: 'bathrooms', label: 'Bathrooms' },
      { key: 'floors', label: 'Floors (vacuum & mop)' },
      { key: 'dusting', label: 'Dusting (main areas)' },
      { key: 'trash_removal', label: 'Trash removal' },
    ],
  },
  commercial: {
    standard_clean: [
      { key: 'restrooms', label: 'Restrooms' },
      { key: 'break_room', label: 'Break room' },
      { key: 'reception_lobby', label: 'Reception / lobby' },
      { key: 'conference_rooms', label: 'Conference rooms' },
      { key: 'workstations', label: 'Office workstations' },
      { key: 'floors', label: 'Floors (vacuum & mop)' },
      { key: 'trash_recycling', label: 'Trash & recycling' },
      { key: 'kitchenette', label: 'Kitchenette' },
    ],
    deep_clean: [
      { key: 'restrooms', label: 'Restrooms (deep scrub)' },
      { key: 'break_room', label: 'Break room' },
      { key: 'reception_lobby', label: 'Reception / lobby' },
      { key: 'conference_rooms', label: 'Conference rooms' },
      { key: 'workstations', label: 'Office workstations' },
      { key: 'floors', label: 'Floors (vacuum & mop)' },
      { key: 'high_dusting', label: 'High dusting' },
      { key: 'vents', label: 'Vents & air returns' },
      { key: 'upholstery', label: 'Upholstered furniture' },
      { key: 'interior_windows', label: 'Interior windows' },
      { key: 'baseboards', label: 'Baseboards' },
      { key: 'trash_recycling', label: 'Trash & recycling' },
    ],
    move_out: [
      { key: 'restrooms', label: 'Restrooms (full clean)' },
      { key: 'break_room', label: 'Break room' },
      { key: 'reception_lobby', label: 'Reception / lobby' },
      { key: 'conference_rooms', label: 'Conference rooms' },
      { key: 'workstations', label: 'Office workstations' },
      { key: 'floors', label: 'Floors (vacuum & mop)' },
      { key: 'storage_areas', label: 'Storage areas' },
      { key: 'loading_dock', label: 'Loading dock' },
      { key: 'interior_windows', label: 'Interior windows' },
      { key: 'exterior_entry', label: 'Exterior entry & signage' },
      { key: 'trash_recycling', label: 'Trash & recycling' },
    ],
    post_construction: [
      { key: 'debris_removal', label: 'Debris removal' },
      { key: 'dust_surfaces', label: 'Dust all surfaces' },
      { key: 'floors', label: 'Floors (sweep, mop, detail)' },
      { key: 'restrooms', label: 'Restrooms' },
      { key: 'windows', label: 'Windows & glass' },
      { key: 'fixtures', label: 'Fixtures & hardware' },
      { key: 'kitchenette', label: 'Kitchenette / break area' },
      { key: 'exterior_entry', label: 'Exterior entry' },
    ],
  },
};

export function getServiceTypesForCategory(category) {
  return SERVICE_TYPES_BY_CATEGORY[category] || [];
}

export function getScopeItems(category, serviceType) {
  return SCOPE_ITEMS_BY_CATEGORY[category]?.[serviceType] || [];
}

export function getScopeItemLabel(category, serviceType, key) {
  const item = getScopeItems(category, serviceType).find((i) => i.key === key);
  return item?.label || key;
}

export const propertyCategoryOptions = PROPERTY_CATEGORIES.map((value) => ({
  value,
  label: PROPERTY_CATEGORY_LABELS[value],
}));

export function serviceTypeOptionsForCategory(category) {
  return getServiceTypesForCategory(category).map((value) => ({
    value,
    label: SERVICE_TYPE_LABELS[value],
  }));
}
